import styled from "@emotion/styled";
import { lightGrey2, white } from "@stepfinance/react";
import type { FC } from "react";
import React from "react";

import { ReactComponent as InfoIcon } from "../../assets/card-info.svg";

type InfoCardProps = {
  title: string;
  type?: "info" | "warn";
  children: React.ReactNode;
};
export const InfoCard: FC<InfoCardProps> = ({ title, children, type }) => {
  let backgroundColor;
  let iconColor;
  switch (type) {
    case "info": {
      iconColor = "#177DDC";
      backgroundColor = "#111d2c";
      break;
    }
    case "warn": {
      iconColor = "#D89614";
      backgroundColor = "#2B2111";
      break;
    }
    default: {
      iconColor = "#177DDC";
      backgroundColor = "#111d2c";
      break;
    }
  }

  return (
    <Card backgroundColor={backgroundColor} iconColor={iconColor}>
      <div className="icon-wrapper">
        <InfoIcon height={24} width={24} />
      </div>
      <div>
        <span className="header">{title}</span>
        <div className="content">{children}</div>
      </div>
    </Card>
  );
};

const Card = styled.div<{ backgroundColor: string; iconColor: string }>`
  display: flex;
  padding: 16px;
  background: ${({ backgroundColor }) => backgroundColor};
  .icon-wrapper {
    padding: 4px 16px 0px 0px;
    svg {
      path {
        fill: ${({ iconColor }) => iconColor};
      }
    }
  }
  justify-content: flex-start;
  .header {
    font-weight: 700;
    font-size: 16px;
    display: block;
    color: ${white};
  }
  .content {
    color: ${lightGrey2};
    margin-top: 10px;
  }
`;
